
import React from 'react';
import { cn } from '@/lib/utils';

interface NavItemProps {
  icon: React.ReactNode;
  title: string;
  path: string;
  active?: boolean;
  onClick: () => void;
  collapsed: boolean;
}

const NavItem: React.FC<NavItemProps> = ({
  icon,
  title,
  active,
  onClick,
  collapsed
}) => {
  return (
    <button
      type="button"
      className={cn(
        "flex items-center gap-3 w-full px-3 py-2 rounded-md text-sm transition-colors",
        "hover:bg-accent hover:text-accent-foreground",
        active ? "bg-accent text-accent-foreground font-medium" : "text-muted-foreground",
        collapsed ? "justify-center" : "justify-start"
      )}
      onClick={onClick}
    >
      <span className="flex-shrink-0">{icon}</span>
      {!collapsed && <span className="truncate">{title}</span>}
    </button>
  );
};

export default NavItem;
